/**
 * Presence-aware party param. Absent → { present:false, value:'' } (fall back
 * to saved). Present (incl. empty) → explicit URL override; empty = All.
 */
export const parsePartyNameParam = (searchParams, key) => {
  if (!searchParams.has(key)) return { present: false, value: '' };
  return { present: true, value: (searchParams.get(key) || '').trim() };
};

/**
 * Write a single party name. Empty clears the param (All).
 */
export const setPartyNameParam = (searchParams, setSearchParams, key, value) => {
  const params = new URLSearchParams(searchParams);
  const next = (value || '').trim();
  if (next) params.set(key, next);
  else params.delete(key);
  setSearchParams(params, { replace: true });
};

/**
 * Effective party filter: explicit URL (incl. empty All) > saved-if-in-options > All.
 */
export const resolvePartyFilter = (urlField, savedValue, options) => {
  if (urlField.present) return urlField.value || '';
  const saved = typeof savedValue === 'string' ? savedValue.trim() : '';
  if (!saved) return '';
  if (Array.isArray(options) && options.includes(saved)) return saved;
  return '';
};
